import React from 'react';

const BillingToggle = ({ selectedCycle, onCycleChange, discount }) => {
  const billingOptions = [
    { id: 'monthly', label: 'Monthly', discount: 0 },
    { id: 'quarterly', label: 'Quarterly', discount: 15 },
    { id: 'yearly', label: 'Yearly', discount: 30 },
  ];

  return (
    <div className="billing-toggle">
      <div className="toggle-container">
        {billingOptions.map((option) => (
          <button
            key={option.id}
            className={`toggle-option ${selectedCycle === option.id ? 'active' : ''}`}
            onClick={() => onCycleChange(option.id)}
          >
            <span className="option-label">{option.label}</span>
            {/* {option.discount > 0 && (
              <span className="discount-badge">Save {option.discount}%</span>
            )} */}
          </button>
        ))}
      </div>

      {/* {discount > 0 && (
        <div className="discount-message">
          <i className="ni ni-tag"></i>
          <span>
            You'll save {discount}% with {selectedCycle} billing
          </span>
        </div>
      )} */}
    </div>
  );
};

export default BillingToggle;
